import React, {useMemo} from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';

const Default = () => {

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">
            <KPI
                title="Number of mileage records"
                icon="faTally"
                dataProviderName={'statisticsviews/item/count/cars/traceKm'}
            />
            <KPI
                title="Vehicles"
                icon="faCar"
                dataProviderName={'statisticsviews/item/count/cars/car'}
            />
        </Box>
        <List />
    </>,[])

}

export default Default;


